import { render, staticRenderFns } from "./HistoriaPatologica.vue?vue&type=template&id=5b558177&"
import script from "./HistoriaPatologica.vue?vue&type=script&lang=js&"
export * from "./HistoriaPatologica.vue?vue&type=script&lang=js&"
import style0 from "./HistoriaPatologica.vue?vue&type=style&index=0&id=5b558177&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports